import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: '代工服務的最低起訂量是多少？',
    a: '依據不同劑型與配方複雜度，最低起訂量有所不同。一般膠囊最低起訂量約為 30,000 顆 ，歡迎洽詢業務人員確認您的需求。',
  },
  {
    q: '可以提供哪些劑型的代工服務？',
    a: '康永生技提供粉劑、錠劑、硬膠囊、軟膠囊、果凍、茶包、液劑，共七種劑型。',
  },
  {
    q: '我只有產品概念，沒有配方，可以合作嗎？',
    a: '完全可以！透過 ODM 模式，您只需提供品牌定位與功效訴求，研發團隊將為您量身設計配方，無需任何技術背景。',
  },
  {
    q: '代工產品是否符合台灣健康食品法規？',
    a: '是的，康永生技熟悉健康食品衛生管理法規，可協助客戶進行產品標示審查、健康食品認證申請及相關法規送件，確保產品合法上市。',
  },
  {
    q: '樣品到正式量產需要多久？',
    a: '樣品製作通常需 2～4 週，確認後進入量產約需 4～8 週，視產品複雜度與訂單規模而定。詳細時程可在諮詢時與業務確認。',
  },
  {
    q: '是否提供包裝與標示設計服務？',
    a: '是的，我們提供包裝設計建議與標示內容審查，也可配合客戶自行提供的設計稿進行生產，確保包裝符合相關法規要求。',
  },
];

export default function ServiceFaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-14 lg:gap-20 items-start">
          {/* Left */}
          <div className="w-full lg:w-1/3 flex-shrink-0">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5 border border-green-200">
              常見問題
            </span>
            <h2 className="text-[#1a2e1a] font-bold leading-tight mb-6">
              代工服務<br />常見疑問解答
            </h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] mb-8">
              如果您有其他問題，歡迎直接聯絡我們的業務團隊，我們將在一個工作天內回覆。
            </p>
            <Link
              to="/contact/form"
              className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[0.9375rem] px-6 py-3 rounded-full transition-all duration-300 cursor-pointer"
            >
              聯絡我們
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* Right */}
          <div className="w-full lg:w-2/3">
            <div className="space-y-3">
              {faqs.map((faq, idx) => (
                <div
                  key={idx}
                  className={`bg-white rounded-xl border transition-all duration-200 overflow-hidden ${openIdx === idx ? 'border-[#4CAF50]/40' : 'border-gray-100'}`}
                >
                  <button
                    className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                    onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                  >
                    <span className={`text-[1rem] font-semibold leading-snug pr-4 ${openIdx === idx ? 'text-[#4CAF50]' : 'text-[#1a2e1a]'}`}>
                      {faq.q}
                    </span>
                    <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${openIdx === idx ? 'bg-[#4CAF50] text-white' : 'bg-green-50 text-[#4CAF50]'}`}>
                      <i className={`text-sm ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`} />
                    </div>
                  </button>
                  {openIdx === idx && (
                    <div className="px-6 pb-5">
                      <p className="text-gray-600 text-[0.9375rem] leading-[1.75]">{faq.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
